import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import * as _ from 'lodash';
import { PropTypes } from 'prop-types';
import CommentBox from '../../CommentBox';
import * as taskService from '../../../../services/domain/taskService';
import GradesComponent from '../GradesComponent';
import PanelTextarea from '../../CommonComponents/PanelTextarea';
import { MAX_LENGTH_VARIABLES } from '../../../../const';

class StudentGrade extends Component {
  static propTypes = {
    task: PropTypes.any,
    toggleEditMode: PropTypes.func,
    isEditMode: PropTypes.bool,
    studentResults: PropTypes.object,
    onInputComment: PropTypes.func,
    evaluatedStudent: PropTypes.any,
    comment: PropTypes.any,
    emojis: PropTypes.any,
    selectedGrade: PropTypes.any,
    onGradeClick: PropTypes.any,
    isTeacher: PropTypes.bool,
    uploadingFile: PropTypes.any,
    onChangeFile: PropTypes.func,
    secondTryEvaluated: PropTypes.bool,
    isFirstTry: PropTypes.bool
  };

  constructor(props, context) {
    super(props, context);

    this.renderCommentBox = this.renderCommentBox.bind(this);
    this.state = {};
  }

  componentDidMount() {
    const { task, evaluatedStudent } = this.props;
    const studentGrade = task.studentAttempts[evaluatedStudent._id];
    if (studentGrade) {
      this.setState({
        hoverGrade: undefined
      });
    }
  }

  renderCommentBox(evaluation = {}) {
    const { task, evaluatedStudent, toggleEditMode, isTeacher, isFirstTry, comment } = this.props;
    const studentGrade = isFirstTry
      ? taskService.getTaskFirstGrade(task, evaluatedStudent._id)
      : taskService.getTaskGrade(task, evaluatedStudent._id);

    return (
      <CommentBox
        userId={evaluation.updatedBy ? evaluation.updatedBy : task.teacherImage}
        comment={comment}
        toggleEditMode={toggleEditMode}
        isTeacher={isTeacher}
        grade={studentGrade}
        showCommentBox={studentGrade !== null}
        isFirstTry={isFirstTry}
      />
    );
  }

  renderCommentTextArea() {
    const { comment, onInputComment } = this.props;

    return (
      <PanelTextarea
        placeholder={`${I18n.t('panels.assignment.addComment')}`}
        label={`${I18n.t('panels.assignment.commentGrade')}`}
        className={'comment-input'}
        onInput={onInputComment}
        maxCharacters={MAX_LENGTH_VARIABLES.COMMENT}
        value={comment}
      />
    );
  }

  editGradeAndComment() {
    const { emojis, selectedGrade, onGradeClick } = this.props;
    const { hoverGrade } = this.state;

    return (
      <div>
        <span className="section-title-label">{I18n.t('panels.assignment.editEvaluation')}</span>
        <div className="grades-component">
          <GradesComponent
            emojis={emojis}
            hoverGrade={hoverGrade}
            onGradeClick={onGradeClick}
            selectedGrade={selectedGrade}
          />
        </div>
        <div className="global-task-review-container">{this.renderCommentTextArea()}</div>
      </div>
    );
  }

  render() {
    const { selectedGrade, studentResults, isEditMode, secondTryEvaluated, toggleEditMode } = this.props;

    const hasRate = !_.isNil(selectedGrade) || !_.isNil(studentResults.evaluation && studentResults.evaluation.grade);
    const showCommentBox = hasRate && !isEditMode;
    const multipleStudentResponses = studentResults && studentResults.responses && studentResults.responses.length > 1;

    if ((multipleStudentResponses && secondTryEvaluated === false) || isEditMode) {
      if (!isEditMode) {
        toggleEditMode();
      }
      return this.editGradeAndComment();
    }

    if (studentResults && showCommentBox) {
      return this.renderCommentBox(studentResults.evaluation);
    }

    return <div>{!secondTryEvaluated && this.editGradeAndComment()}</div>;
  }
}

export default StudentGrade;
